/* src/app/shared/components/controls/common-search/common-search.component.scss */
.common-search-field {
  font-family: "Lato" !important;
  display: flex !important;
  align-items: center !important;
  padding: 0px !important;
  width: 100% !important;
  height: 24px !important;
  --mat-form-field-container-height: 24px;
  --mat-form-field-container-vertical-padding: 1px;
}
.common-search-field .search-icon {
  color: var(--disabled-state) !important;
  font-size: 13px !important;
}
.common-search-field .search-icon::before {
  position: relative;
  top: -2px;
}
.common-search-field .searchTextField {
  font-size: 14px !important;
  font-family: "Lato" !important;
  font-style: normal !important;
  line-height: 16px !important;
  font-weight: 400 !important;
  color: var(--header-text) !important;
  border: 0 !important;
  width: calc(100% - 12px) !important;
  height: 16px !important;
  padding: 0 !important;
  margin-left: 6px !important;
}
.common-search-field .searchTextField::placeholder {
  color: var(--light-grey) !important;
}
.common-search-field .cross-icon {
  color: var(--primary);
  cursor: pointer;
  font-size: 14px !important;
  opacity: 0.5;
  width: 14px;
  height: 14px;
  justify-content: center;
  text-align: center;
}
.common-search-field .cross-icon:hover {
  opacity: 1;
}
.common-search-field .cross-icon:focus,
.common-search-field .cross-icon:focus-visible {
  opacity: 0.5;
  outline: none;
}
.common-search-field.mat-form-field-appearance-legacy .mat-form-field-label {
  font-size: 14px;
  color: var(--light-grey) !important;
  width: 100%;
}
.common-search-field .mat-form-field .mat-focused .mat-form-field-label {
  color: var(--light-grey) !important;
}
.common-search-field .mat-form-field-appearance-legacy .mat-form-field-wrapper {
  width: 100% !important;
}
::ng-deep .common-search-field.mat-form-field-appearance-legacy .mat-form-field-wrapper {
  width: 100% !important;
}
::ng-deep .common-search-field.mat-focused .mat-form-field-underline,
::ng-deep .common-search-field.mat-focused .mat-form-field-ripple {
  background-color: var(--black, #000000) !important;
}
::ng-deep .common-search-field.mat-focused .mdc-line-ripple::before,
::ng-deep .common-search-field.mat-focused .mdc-line-ripple::after,
::ng-deep .common-search-field.mat-focused .mdc-notched-outline__leading,
::ng-deep .common-search-field.mat-focused .mdc-notched-outline__notch,
::ng-deep .common-search-field.mat-focused .mdc-notched-outline__trailing {
  border-color: var(--black, #000000) !important;
}
.common-search-field.mat-mdc-form-field .mat-mdc-form-field-icon-prefix {
  width: 14px;
  height: 14px;
}
.common-search-field.mat-mdc-form-field .mat-mdc-text-field-wrapper,
.common-search-field.mat-mdc-form-field .mat-mdc-form-field-flex,
.common-search-field.mat-mdc-form-field .mdc-text-field {
  min-height: 24px !important;
  height: 24px !important;
  align-items: center !important;
}
.common-search-field.mat-mdc-form-field .mat-mdc-form-field-infix {
  height: 24px !important;
  --mat-form-field-container-vertical-padding: 1px !important;
  bottom: 6px;
}
.sub-header-text.search-helper-hidden {
  visibility: hidden;
}
/*# sourceMappingURL=common-search.component-AJT62P5R.css.map */
